<template>
  <vx-card class="mt-base">
    <div>
      <h4 class="mb-2">Thank you Letter</h4>
      <p class="my-5" v-if="loginType == 'student'">
        Your Thank you letter for this job experience is shown below (if it is blank then you did
        not complete it).
      </p>
      <p class="my-5" v-else>
        This student's Thank you letter for this job experience is shown below (if it is blank then
        they did not complete it).
      </p>

      <template v-if="postwork != null">
        <form id="form">
          <p class="mb-1 text-left">{{ postwork.thankyou_letter.name }}</p>
          <p class="mb-1 text-left">{{ postwork.thankyou_letter.street }}</p>
          <p class="mb-1 text-left">
            {{ postwork.thankyou_letter.town }}, {{ postwork.thankyou_letter.state }},
            {{ postwork.thankyou_letter.postcode }}
          </p>
          <p class="mb-1 text-left">{{ postwork.thankyou_letter.phone }}</p>
          <p class="mb-1 text-left">{{ postwork.thankyou_letter.email }}</p>
          <p class="mb-5 text-left">Date {{ postwork.thankyou_letter.date }}</p>

          <p class="mb-5" style="white-space: pre-line">{{ postwork.thankyou_letter.recipient }}</p>

          <p class="mb-5">Dear {{ postwork.thankyou_letter.addressed_to }},</p>

          <p class="mb-8" style="white-space: pre-line">
            {{ postwork.thankyou_letter.letter_body }}
          </p>

          <p class="mb-1">Yours sincerely,</p>
          <p class="mb-1">{{ postwork.thankyou_letter.signature }}</p>
        </form>
        <div v-if="loginType == 'student'" class="pt-10">
          <button class="btn btn-secondary btn-size-medium" @click="downloadThankyouLetter">
            View Thank you Letter
          </button>
          <vs-progress indeterminate color="primary" v-if="downloadingThankyouLetter"></vs-progress>
        </div>
      </template>
    </div>
  </vx-card>
</template>

<script>
import state from '@/store/store';
import store from '@/store/store';
import theApi from '@/mixins/theApi';

export default {
  computed: {
    loginType() {
      return localStorage.getItem('login_type');
    },
    experience() {
      const loginType = localStorage.getItem('login_type');
      if (loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.$route.params.id);
      } else {
        return state.getters['authTeacher/experience'];
      }
    },
    postwork() {
      if (
        typeof this.experience.postwork !== 'undefined' &&
        this.experience.postwork != null &&
        typeof this.experience.postwork.thankyou_letter !== 'undefined' &&
        this.experience.postwork.thankyou_letter != null
      )
        return this.experience.postwork;
      else return null;
    },
  },
  data() {
    return {
      downloadingThankyouLetter: false,
    };
  },
  methods: {
    downloadThankyouLetter() {
      this.downloadingThankyouLetter = true;
      const formDataTL = new FormData();
      formDataTL.append('student_vje_id', this.$route.params.id);
      theApi.methods.makeCall(false, 'thankyou_letter/download', 'post', formDataTL).then(
        (data) => {
          if (data.status == 'OK') {
            store.dispatch('popup/showIframePopup', data.url);
            this.downloadingThankyouLetter = false;
          }
        },
        () => {
          this.downloadingThankyouLetter = false;
        },
      );
    },
  },
};
</script>
